import { storage } from "../firebase";

let cachedUrl: string = "";

export const getAvatarPlaceholder = async (): Promise<string> => {
  if (cachedUrl) return cachedUrl;
  const ref = storage.ref('statics/user-placeholder.png');
  cachedUrl = await ref.getDownloadURL();
  return cachedUrl;
};